"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_ALLOWED_TOP_LEVEL_DOMAINS = exports.CACHE_CONTROL_VALUE = exports.CACHE_CONTROL_HEADER_NAME = void 0;
exports.CACHE_CONTROL_HEADER_NAME = 'Cache-Control';
exports.CACHE_CONTROL_VALUE = 'no-cache';
exports.AUTH_ALLOWED_TOP_LEVEL_DOMAINS = [
    '.easygenerator.com',
    '.uat-easygenerator.com',
    '.staging-easygenerator.com',
    'localhost'
];
